import React from 'react';
import ReservationActionCell from '../Campaign/QuoteAndBooking/ReservationActionCell';
import ReservationTimer from '../generic/ReservationTimer';

const ReservationsGridColumnDefinitions = (
    loadData,
    reservationTimeValues,
    scrolling = false,
    workflowId = undefined
) => {
    const style = {
        height: 34
    };

    return [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 3,
            headerName: window.translate('Release or Extend'),
            field: 'custom',
            type: 'action',
            style: { ...style, width: 80, maxWidth: 80, textAlign: 'left' },
            hideInColumnFilter: true,
            showInList: true,
            sortable: false,
            component: (
                <ReservationActionCell
                    readOnly={false}
                    reservationTimeValues={reservationTimeValues}
                    getQuotes={loadData}
                    scrolling={scrolling}
                    workflowId={workflowId}
                />
            )
        },
        {
            displayOrder: 7,
            headerName: window.translate
                ? window.translate('Campaign Name')
                : '',
            field: 'name',
            type: 'text',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 9,
            headerName: window.translate ? window.translate('Version') : '',
            field: 'versionName',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 10,
            headerName: window.translate('Advertiser'),
            field: 'advertiserAccountName',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 11,
            headerName: window.translate('Agency'),
            field: 'agencyAccountName',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 12,
            headerName: window.translate('Start Date'),
            field: 'startDate',
            width: 115,
            type: 'date',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 13,
            headerName: window.translate('End Date'),
            field: 'endDate',
            width: 115,
            type: 'date',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 14,
            headerName: window.translate('Budget'),
            field: 'budget',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 15,
            headerName: window.translate('Spend'),
            field: 'amount',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 16,
            headerName: window.translate('Stations'),
            field: 'stationCount',
            type: 'text',
            width: 'auto',
            style: { ...style, textAlign: 'center' },
            showInList: true,
            sortable: true,
            sortOrder: 'desc'
        },
        {
            displayOrder: 17,
            headerName: window.translate('Spots'),
            field: 'spotCount',
            type: 'text',
            width: 'auto',
            style: { ...style, textAlign: 'center' },
            showInList: true,
            sortable: true,
            sortOrder: 'desc'
        },
        {
            displayOrder: 18,
            headerName: window.translate('Reservation Time Remaining'),
            field: 'reservedUntil',
            type: 'custom',
            component: <ReservationTimer reservationsTab />,
            style: {
                ...style,
                width: 133,
                textAlign: 'right',
                paddingRight: 10
            },
            customType: 'component',
            showInList: true,
            sortable: true,
            sortOrder: 'desc'
        },
        {
            displayOrder: 19,
            headerName: window.translate('Campaign Owner'),
            field: 'campaignOwnerName',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: 'desc',
            style
        },
        {
            displayOrder: 20,
            headerName: window.translate('Created Date'),
            field: 'createdDate',
            width: 115,
            type: 'hidden',
            showInList: false,
            sortable: true,
            sortOrder: 'desc',
            style
        }
    ];
};

export default ReservationsGridColumnDefinitions;
